import dragoncity from "./dragon-city";
import monsterLegends from "./monster-legends";
import wordLife from "./word-life";
import twoDots from "./two-dots";
export default {
  "dragon-city": dragoncity,
  "monster-legends": monsterLegends,
  "word-life": wordLife,
  "two-dots": twoDots
};
